import BodypartSelector from "./BodypartSelector";

export default BodypartSelector;
